export const EXCLUDED_IDS_BY_REGION = {
  metro: new Set<number>([
    6, 21, 43, 191, 202, 209, 278, 283, 285, 360, 402, 519, 538, 641, 953, 1051,
  ]),
  ch: new Set<number>([247, 326]),
  gangwon: new Set<number>([162, 199, 463, 1173]),
  honam: new Set<number>([550, 611, 666, 708, 766, 771, 792, 830, 833]),
  dggb: new Set<number>([42, 76, 164, 194, 229, 262, 325, 585, 595, 680, 863]),
  gyeongsang: new Set<number>([97, 98, 111, 156, 700, 915, 996]),
  jeju: new Set<number>([505]),
};
